(function () {
  'use strict';
  angular.module('eclipseApp.myAccount')

    .controller('learnMoreOnlineBillingCtrl', ['$scope',
      '$rootScope',
      '$http',
      '$modalInstance',
      'uteEndpoint',
      'data',
      'commonService',
      'onlineBillingService',
      'dtmServiceConstants', 'dtmService',
      '$translate', function ($scope,
                              $rootScope,
                              $http,
                              $modalInstance,
                              uteEndpoint,
                              data,
                              commonService,
                              onlineBillingService,
                              dtmServiceConstants,
                              dtmService,
                              $translate) {
      $scope.actionType = data.actionType;
      var paperBillingCount = 0;
      $scope.emailExist = false;
      $scope.paperBillExist = false;
      $scope.showLegacyWidget = data.legacyWidget;
      $scope.accountData = data.paperBillingData;
      paperBillingCount = data.paperBillingCount;
      var emailForOnlineBilling = data.customerEmail;
      $scope.selectedAccountArray = [];
      $scope.account = {};
      $scope.emailUpdateFailed = false;
      $scope.billStatus = '';
      $scope.finalAccountPaperObj = [];
      $scope.finalAccountOnlineObj = [];
      $(".ute-input-checkbox").prop("checked", true) ;
      if (emailForOnlineBilling) {
        $scope.emailExist = true;
        $scope.account.customerEmail = $scope.account.confirmCustomerEmail = emailForOnlineBilling;
      }

      $scope.changeToOnlineBill = function(){
        dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerStart.name);
        if (paperBillingCount === 1 && $scope.showLegacyWidget) {
          $scope.screenToRender = 'processing';
          $scope.selectedAccountArray.push($scope.accountData[0].accountNumber);
          $scope.switchNow($scope.selectedAccountArray);
        }
        else if (paperBillingCount >=1) {
          angular.forEach($scope.accountData, function(account){
            account.selected = true ;
          });
          $scope.screenToRender = 'multipleAccount';
        }
      }
      $scope.switchNow = function(accountList) {
        onlineBillingService.switchBillingType(accountList, $scope.account.customerEmail)
          .then(function(data) {
          if(data && data.error && data.error === '550552') {
            $scope.emailUpdateFailed = true;
            $scope.screenToRender = 'error';
            $translate('global.error.label.onlineBillingEmailUpdateFailed').then(function(translatedValue) {
              var dtmServerSideError = 'SS|' + translatedValue;
              dtmService.setVar(dtmServiceConstants.dtmRules.switchOLBBannerError.eVar, dtmServerSideError);
              dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerError.name);
            });
          }
          else if (data && data.error && data.error === '550553') {
            $scope.emailUpdateFailed = false;
            $scope.screenToRender = 'error';
            var errorKey = 'global.error.label.onlineBillingChangeFailed';
            if($scope.showLegacyWidget){
               errorKey = 'global.error.label.onlineBillingCannotSwitch';
            }
            $translate(errorKey).then(function(translatedValue) {
              var dtmServerSideError = 'SS|' + translatedValue;
              dtmService.setVar(dtmServiceConstants.dtmRules.switchOLBBannerError.eVar, dtmServerSideError);
              dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerError.name);
            });
          }
          else {
            console.log(data);
            var successCount = 0;
            var objCount = 0 ;
            var emailUpdateFailureCount = 0;
            var genericErrorCount = 0;
            var onBillHoldCount = 0;

            console.log($scope.finalAccountPaperObj);
            console.log($scope.finalAccountOnlineObj);
            if ($scope.finalAccountPaperObj && $scope.finalAccountPaperObj.length > 0) {
              $scope.paperBillExist = true;
            }
            angular.forEach(data, function(dataObj) {
              objCount++ ;
              if (dataObj.error === "" || dataObj.error === null ) {
                angular.forEach(commonService.accountDetails, function(accountDetail, accountDetailKey) {
                     if (dataObj.accountNumber === accountDetail.accountNumber) {
                        accountDetail.billingType = 'Online' ;
                        accountDetail.contactEmail = $scope.account.customerEmail;
                     }
                });
                successCount ++ ;
              }else if(dataObj.error && dataObj.error === '550552') {
                emailUpdateFailureCount++ ;
              }else if (dataObj.error && dataObj.error === '1001524') {
                onBillHoldCount++ ;
              }else if (dataObj.error && dataObj.error === '550553') {
                genericErrorCount++ ;
              }
            });
            if (objCount == successCount) {
              $scope.screenToRender = 'success';
              dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerComplete.name);
            } else {
              $scope.screenToRender = 'error';
              var errorKey = 'global.error.label.onlineBillingChangeFailed';
              if($scope.showLegacyWidget){
                errorKey = 'global.error.label.onlineBillingCannotSwitch';
              }
              if (genericErrorCount > 0) {
                $scope.emailUpdateFailed = false;
              }else if(emailUpdateFailureCount > 0) {
                $scope.emailUpdateFailed = true;
                errorKey = 'global.error.label.onlineBillingEmailUpdateFailed';
              }else if (onBillHoldCount > 0) {
                $scope.emailUpdateFailed = false;
                $scope.billStatus = 'onBillHold';
                errorKey = 'global.error.label.onBillHold';
              }
              $translate(errorKey).then(function(translatedValue) {
                var dtmServerSideError = 'SS|' + translatedValue;
                dtmService.setVar(dtmServiceConstants.dtmRules.switchOLBBannerError.eVar, dtmServerSideError);
                dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerError.name);
              });
            }
          }
        }).catch(function(){
          $scope.screenToRender = 'error';
          var errorKey = 'global.error.label.onlineBillingChangeFailed';
          if($scope.showLegacyWidget){
            errorKey = 'global.error.label.onlineBillingCannotSwitch';
          }
          $translate(errorKey).then(function(translatedValue) {
            var dtmServerSideError = 'SS|' + translatedValue;
            dtmService.setVar(dtmServiceConstants.dtmRules.switchOLBBannerError.eVar, dtmServerSideError);
            dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerError.name);
          });
        });
      }
      $scope.submit = function(form){
        if($scope.showLegacyWidget){
          $scope.screenToRender = 'processing';
          angular.forEach($scope.accountData, function(account){
            if (account.selected) $scope.selectedAccountArray.push(account.accountNumber);
          });
          $scope.switchNow($scope.selectedAccountArray);
        }else{
          if(form && form.$valid) {
            $scope.screenToRender = 'processing';
            angular.forEach($scope.accountData, function(account){
              if (account.selected) {
                var finalAccountOnline = {};
                $scope.selectedAccountArray.push(account.accountNumber);
                finalAccountOnline.accountNumber = account.accountNumber;
                finalAccountOnline.hasWireless = account.hasWireless;
                $scope.finalAccountOnlineObj.push(finalAccountOnline);
              }
              if (!account.selected) {
                var finalAccountPaper = {};
                finalAccountPaper.accountNumber = account.accountNumber;
                finalAccountPaper.hasWireless = account.hasWireless;
                $scope.finalAccountPaperObj.push(finalAccountPaper);
              }
            });
            $scope.switchNow($scope.selectedAccountArray);
          }else{
            if(form && form.$name === 'onlineBillForm') {
              if (form.email.$error.pattern || form.email.$error.required || form.confirmEmail.$error.pattern || form.confirmEmail.$error.required) {
                $translate('global.error.inline.email.invalid').then(function (translatedValue) {
                  var clientSideError = 'CS|' + translatedValue;
                  dtmService.setVar(dtmServiceConstants.dtmRules.switchOLBBannerError.eVar, clientSideError);
                  dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerError.name);
                });
              }
              if (form.confirmEmail.$error.compareTo) {
                $translate('global.error.inline.email.emailMatch').then(function (translatedValue) {
                  var clientSideError = 'CS|' + translatedValue;
                  dtmService.setVar(dtmServiceConstants.dtmRules.switchOLBBannerError.eVar, clientSideError);
                  dtmService.direct(dtmServiceConstants.dtmRules.switchOLBBannerError.name);
                });
              }
            }
          }
        }
      }
      if ($scope.actionType === 'LearnMore') {
        $scope.screenToRender = 'learnMoreOnlineBilling';
      }
      else if ($scope.actionType === 'SwitchNow') {
        $scope.changeToOnlineBill();
      }
      $scope.closeWithUpdate = function(){
          commonService.loadBillingDetails();
          $modalInstance.dismiss();
      }
      $scope.close = function() {
        angular.forEach($scope.accountData, function(account){
          account.selected = true ;
          $modalInstance.dismiss();
        });
      }
      $scope.change = function(){
        var emptyCount = 0;
        var objCount = 0 ;
        $scope.empty = false;
        angular.forEach($scope.accountData, function(account){
          objCount++ ;
          if (!account.selected){
            emptyCount++ ;
          }
        });
        if (objCount == emptyCount) {
          $scope.empty = true;
        } else {
          $scope.empty = false;
        }
      }

      $scope.focusListener = function (field) {
        field.hasFocus = true;
      };

      $scope.blurListener = function(field) {
        field.hasFocus = false;
      };

      $scope.isSubmitEnabled = function (form) {
        return !$scope.empty &&
          form.$valid &&
          $scope.account.customerEmail &&
          $scope.account.customerEmail.length > 0 &&
          $scope.account.confirmCustomerEmail &&
          $scope.account.confirmCustomerEmail.length > 0 &&
          $scope.account.customerEmail === $scope.account.confirmCustomerEmail;
      }
    }]).directive("compareTo", function() {
      return {
        require: "ngModel",
        scope: {
          otherModelValue: "=compareTo"
        },
        link: function(scope, element, attributes, ngModel) {

          ngModel.$validators.compareTo = function(modelValue) {
            return modelValue == scope.otherModelValue;
          };

          scope.$watch("otherModelValue", function(newVal) {
            if(newVal) {
              ngModel.$validate();
            }
          });
        }
      };
    });
})();
